module.exports = __webpack_public_path__ + "img/store-aspdotnetstorefront.c647040e.svg";